import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';

import { NgIf, NgTemplateOutlet } from '@angular/common';
import { TBoxAlign } from '../../directives';
import { CardBodyDirective, CardFooterDirective, CardTitleDirective } from './card-slots';

@Component({
  selector: 'card-container',
  standalone: true,
  template: `
    <ng-container *ngIf="titleTemplate">
      <div class="title">
        <ng-container *ngTemplateOutlet="titleTemplate.tpl; context: { $implicit: context }"></ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="bodyTemplate">
      <div class="body">
        <ng-container *ngTemplateOutlet="bodyTemplate.tpl; context: { $implicit: context }"></ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="footerTemplate">
      <div class="footer">
        <ng-container *ngTemplateOutlet="footerTemplate.tpl; context: { $implicit: context }"></ng-container>
      </div>
    </ng-container>
  `,
  imports: [NgIf, NgTemplateOutlet],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'card-container'
  }
})
export class CardContainerComponent implements OnInit {
  context: any;

  @ContentChild(CardFooterDirective, { static: true })
  footerTemplate: CardFooterDirective;

  @ContentChild(CardBodyDirective, { static: true })
  bodyTemplate: CardBodyDirective;

  @ContentChild(CardTitleDirective, { static: true })
  titleTemplate: CardTitleDirective;

  @Input()
  justifyContent: TBoxAlign = 'start';

  @Input()
  alignItems: TBoxAlign;

  @Input()
  @HostBinding('class.densed')
  densed: boolean;

  constructor() {}

  ngOnInit(): void {}
}
